"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _radio = _interopRequireDefault(require("@kyruus/radio"));
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const RadioButton = exports.RadioButton = /*#__PURE__*/(0, _base.default)(_radio.default, process.env.NODE_ENV === "production" ? {
  target: "e8l89uk0"
} : {
  target: "e8l89uk0",
  label: "RadioButton"
})(process.env.NODE_ENV === "production" ? {
  name: "6kn0c0",
  styles: "padding:0;flex-wrap:wrap;>div{justify-content:start;>div{width:8rem;flex-grow:0;}}"
} : {
  name: "6kn0c0",
  styles: "padding:0;flex-wrap:wrap;>div{justify-content:start;>div{width:8rem;flex-grow:0;}}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0d4VWkvWWVzTm9CdXR0b25zL3N0eWxlcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHd0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvR3hVaS9ZZXNOb0J1dHRvbnMvc3R5bGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFJhZGlvIGZyb20gJ0BreXJ1dXMvcmFkaW8nO1xuXG5leHBvcnQgY29uc3QgUmFkaW9CdXR0b24gPSBzdHlsZWQoUmFkaW8pYFxuICBwYWRkaW5nOiAwO1xuICBmbGV4LXdyYXA6IHdyYXA7XG5cbiAgPiBkaXYge1xuICAgIGp1c3RpZnktY29udGVudDogc3RhcnQ7XG4gICAgPiBkaXYge1xuICAgICAgd2lkdGg6IDhyZW07IC8vIGZyb20gcG1jXG4gICAgICBmbGV4LWdyb3c6IDA7XG4gICAgfVxuICB9XG59XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});